import { GetServerSideProps } from 'next'
import Head from 'next/head'

import getIsScoredJourney from '@utils/getIsScoredJourney'

import AlternativeProductsTableRoute from '@routes/AlternativeProductsTableRoute'
import UnscoredAlternativeProductsTableRoute from '@routes/UnscoredAlternativeProductsTableRoute/UnscoredAlternativeProductsTableRoute'

import NotFoundPage from '@components/NotFoundPage'

interface AlternativeProductsPageProps {
    isScoredJourney: boolean
}

export default function AlternativeProductsPage({
    isScoredJourney,
}: AlternativeProductsPageProps) {
    return (
        <>
            <Head>
                <title>
                    Compare the UK’s Top Credit Cards with TotallyMoney
                </title>
            </Head>
            {isScoredJourney ? (
                <AlternativeProductsTableRoute />
            ) : (
                <UnscoredAlternativeProductsTableRoute />
            )}
        </>
    )
}

export const getServerSideProps: GetServerSideProps<
    AlternativeProductsPageProps
> = async ({ query }) => {
    return {
        props: {
            isScoredJourney: getIsScoredJourney(query),
        },
    }
}
